import React, { useEffect, useState } from "react";
import logo from "../img/easyILA_Logo.svg";
import logoLight from "../img/easyILA_Logo_White.svg";
import { Link, useNavigate } from "react-router-dom";
import Loader from "../components/loader";
import { Helmet } from "react-helmet-async";
import Navbar from "./Header/Navbar";
import Footer from "./Footer";
import CollapseHeaders from "./collapse-header";

const Errorpage = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const handlePageLoad = () => {
      setIsLoading(false);
    };

    if (document.readyState === "complete") {
      setIsLoading(false);
    } else {
      window.addEventListener("load", handlePageLoad);
    }

    return () => window.removeEventListener("load", handlePageLoad);
  }, []);

  const [isScrolled, setIsScrolled] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  if (isLoading) {
    return <Loader />;
  }

  return (
    <>
      <div>
        {/* Navbar */}
        <CollapseHeaders />
        {/* Header Section */}
        {/* <header id="hero-area" loading="lazy"> */}
        {/* Navbar End */}
        <div className="container thankyou">
          <div className="row justify-content-md-center">
            <div
              className="col-md-10"
              style={{ flex: "100%", maxWidth: "100%", paddingTop: "100px" }}
            >
              <div
                className="contents text-center"
                style={{ padding: "10% 0" }}
              >
                <h1 className="wow fadeInDown text-white" data-wow-delay="0.3s">
                  OOPS!!
                </h1>
                <h3 className="wow fadeInDown text-white">404 Not Found</h3>
                <p className="lead wow fadeIn text-white">
                  The page you are trying to access doesn't exist or has been
                  removed <br /> Try going back to our home page
                </p>
                <button
                  type="button"
                  className="btn btn-light"
                  onClick={() => {
                    navigate("/home");
                  }}
                >
                  HOME
                </button>
              </div>
            </div>
          </div>
        </div>
        {/* </header> */}

        {/* Footer Section Start */}
        <Footer />
        {/* Footer Section End */}

        {/* Go To Top Link */}
      </div>
    </>
  );
};

export default Errorpage;
